var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3.75C10.8358 3.75 10.5 3.41421 10.5 3C10.5 2.58579 10.8358 2.25 11.25 2.25H15C15.4142 2.25 15.75 2.58579 15.75 3V6.75C15.75 7.16421 15.4142 7.5 15 7.5C14.5858 7.5 14.25 7.16421 14.25 6.75V4.81066L8.03033 11.0303C7.73744 11.3232 7.26256 11.3232 6.96967 11.0303C6.67678 10.7374 6.67678 10.2626 6.96967 9.96967L13.1893 3.75H11.25ZM2.90901 5.15901C3.33097 4.73705 3.90326 4.5 4.5 4.5H8.25C8.66421 4.5 9 4.83579 9 5.25C9 5.66421 8.66421 6 8.25 6H4.5C4.30109 6 4.11032 6.07902 3.96967 6.21967C3.82902 6.36032 3.75 6.55109 3.75 6.75V13.5C3.75 13.6989 3.82902 13.8897 3.96967 14.0303C4.11032 14.171 4.30109 14.25 4.5 14.25H11.25C11.4489 14.25 11.6397 14.171 11.7803 14.0303C11.921 13.8897 12 13.6989 12 13.5V9.75C12 9.33579 12.3358 9 12.75 9C13.1642 9 13.5 9.33579 13.5 9.75V13.5C13.5 14.0967 13.2629 14.669 12.841 15.091C12.419 15.5129 11.8467 15.75 11.25 15.75H4.5C3.90326 15.75 3.33097 15.5129 2.90901 15.091C2.48705 14.669 2.25 14.0967 2.25 13.5V6.75C2.25 6.15326 2.48705 5.58097 2.90901 5.15901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/externalLink.09a56c00b19e9b752fd0025ded86de26.svg";
export { ForwardRef as ReactComponent };